import { z } from "zod";
import { countryCodes } from "./country.js";
import { usStateCodes } from "./state.js";

export const ResponseAddress = z.object({
  line1: z.string(),
  line2: z.string().optional(),
  line3: z.string().optional(),
  town: z.string(),
  state: usStateCodes.optional(),
  postCode: z.string(),
  country: countryCodes,
});

export type ResponseAddress = z.infer<typeof ResponseAddress>;
